<template>
    <div class="form-group">
        <div v-if="info_text" class="d-flex align-items-center">
            <label class="mr-1">DNI/NIE/PASAPORTE</label>
            <InfoToolTip :info="info_text" class="pb-1" />
        </div>

        <label v-else>DNI/NIE/PASAPORTE</label>
        <ValidationProvider name="DNI/NIE/Pasaporte" rules="required" v-slot="{ errors }">
            <input 
                v-model="datos_compradores.dni" 
                id="dni"
                type="text" 
                :disabled="desactivar" 
                :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" 
                placeholder="DNI/NIE/PASAPORTE" 
                @input="validarIdentificacion"
            >
            <span v-if="errors[0]" class="invalid-feedback text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ $t('formularios.obligatorio') }}</b></span>
            <span v-if="errorMensaje" class="invalid-feedback text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errorMensaje }}</b></span>
        </ValidationProvider>
    </div>
</template>

<script>
import InfoToolTip from '@/components/common/InfoToolTip';

export default {
    props: ['datos_compradores', 'desactivar', 'info_text'],
    data() {
        return {
            errorMensaje: ''
        }
    },
    methods: {
        validarIdentificacion() {
            const caracteresEspeciales = /[^a-zA-Z0-9]/g;
        
            if (caracteresEspeciales.test(this.datos_compradores.dni)) {
                this.errorMensaje = 'No se permiten caracteres especiales.';
                this.datos_compradores.dni = this.datos_compradores.dni.replace(caracteresEspeciales, ''); // Limpiar caracteres especiales
            } else {
                this.errorMensaje = null;
            }
        }
    },
    watch: {
        'datos_compradores.dni': function() {
            this.validarIdentificacion();
        }
    },
    components: {
        InfoToolTip
    }
}
</script>